import styled from '@emotion/styled'
import { colors } from '../../..'
import { Timestamp } from '../../../content/CardTimestamp/CardTimestamp'
import { calcRem, themedValue } from '../../../__styling'
import { rgba } from 'polished'

export const StyledMilestonesContainer = styled('div')(({ theme }) => ({
    backgroundColor: themedValue(theme, {
        sevennews: colors.white,
        fallback: colors.thewest.greyErmine,
    }),
    padding: theme.margins.sm,
    margin: themedValue(theme, {
        sevennews: calcRem(theme.margins.lg, -7, 0),
        fallback: 0,
    }),
}))

export const StyledMilestonesTimeline = styled('div')(({ theme }) => ({
    '& > a': {
        textDecoration: 'none',
    },
}))

export const StyledMilestone = styled('div')<{ dimmed: boolean }>(
    ({ theme, dimmed }) => ({
        position: 'relative',
        margin: calcRem(0, 20),
        padding: calcRem(0, 14, theme.margins.md),
        borderLeft: `1px solid ${colors.thewest.greySeal}`,
        opacity: dimmed ? 0.2 : 1,
        '&::after': {
            display: 'block',
            position: 'absolute',
            borderRadius: '50%',
            content: `''`,
            left: -5,
            top: 3,
            width: 10,
            height: 10,
            backgroundColor: theme.colors.brand,
            zIndex: 11,
        },
        '&:hover': {
            opacity: 1,
        },
    }),
)

export const StyledMilestoneTimestamp = styled(Timestamp)(({ theme }) => ({
    marginLeft: 0,
    backgroundColor: 'transparent',

    color: themedValue(theme, {
        sevennews: rgba(39, 38, 38, 0.5),
        fallback: theme.colors.palette.black,
    }),
    fontWeight: themedValue(theme, {
        sevennews: 600,
        fallback: 700,
    }),

    fontSize: themedValue(theme, {
        sevennews: calcRem(12),
        fallback: calcRem(15),
    }),
    lineHeight: calcRem(16),
    fontFamily: themedValue(theme, {
        sevennews: theme.fonts.headingAlternative,
        fallback: theme.fonts.sansSerif,
    }),
}))

export const StyledMilestoneTitle = styled('span')(({ theme }) => ({
    textDecoration: 'none',
    color: theme.colors.palette.black,
    fontWeight: themedValue(theme, {
        sevennews: 400,
        fallback: 'inherit',
    }),
    fontFamily: themedValue(theme, {
        sevennews: theme.fonts.headingAlternative,
        fallback: theme.fonts.serif,
    }),
}))

export const StyledMilestonesTitle = styled('h3')(({ theme }) => ({
    fontSize: calcRem(22),
    padding: calcRem(0, theme.margins.md, theme.margins.md),
    margin: 0,
}))
